import { createVuetify } from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { customIcons } from '@/components/icons/CustomIcon';
import { DEFAULT_THEME } from './DefaultTheme';

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'DEFAULT_THEME',
    themes: {
      //others themes
      DEFAULT_THEME,
    },
  },
  defaults: {
    global: {
      clearIcon: 'custom:close',
      hideDetails: 'auto',
    },
    VAppBarNavIcon: {
      icon: 'custom:menu',
    },
    VBtn: {
      variant: 'flat',
      ripple: false,
      class: 'gg-btn',
    },
    VTextField: {
      variant: 'outlined',
      clearable: false,
    },
    VSelect: {
      variant: 'outlined',
      menuIcon: 'custom:arrowDown',
      clearable: false,
      centerAffix: true,
      menuProps: {
        contentClass: '',
      },
      noDataText: '데이터가 없습니다.',
    },
    VAutocomplete: {
      variant: 'outlined',
      menuIcon: 'custom:arrowDown',
      clearable: true,
      centerAffix: true,
      menuProps: {
        contentClass: '',
      },
      noDataText: '데이터가 없습니다.',
    },
    VCheckbox: {
      falseIcon: 'custom:checkboxOff',
      trueIcon: 'custom:checkboxOn',
    },
    VRadio: {
      falseIcon: 'custom:radioOff',
      trueIcon: 'custom:radioOn',
      density: 'compact',
    },
    VCheckboxBtn: {
      falseIcon: 'custom:checkboxOff',
      trueIcon: 'custom:checkboxOn',
      density: 'compact',
    },
    VRadioGroup: {
      density: 'compact',
      falseIcon: 'custom:radioOff',
      trueIcon: 'custom:radioOn',
    },
    VSwitch: {
      inset: true,
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      rows: 4,
      rowHeight: 20,
      noResize: true,
    },
    VTable: {
      fixedHeader: true,
      class: 'gg-table',
    },
    VPagination: {
      totalVisible: 3,
      class: 'gg-pagination',
    },
    VFileInput: {
      variant: 'outlined',
      prependIcon: '',
      appendInnerIcon: 'custom:upload',
    },
    VSnackbar: {
      timeout: 3000,
    },
    VChip: {
      color: 'bodyLight',
      class: 'gg-chip',
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      custom: customIcons,
    },
  },
});
